// Optimally Webforms are rendered in Vue. This is a temporary workaround (because of course)
const $ = window.$

const prefill = async (el, profile) => {
  const field = el.dataset.prefillGigya
  const value = profile[field]
  el.value = value
  $(el).trigger('input') // Activates the Q label thingy
}

const init = ({state: {user}, getters, dispatch}) => {
  $(document).on('page:load', async () => {
    // Prefill
    const inputs = Array.from(document.querySelectorAll('[data-prefill-gigya]'))

    if (inputs.length > 0 && getters['user/isLoggedIn']) {
      if (!user.profileLoaded) {
        await dispatch('user/fetchProfile')
      }

      for (const el of inputs) {
        prefill(el, user.profile)
      }
    }
  })

  $(document).on('page:load form:invalid', () => {
    document.querySelectorAll('[data-role=webform-auth-token]').forEach((el) => {
      el.value = user.token
    })
  })
}

export {
  init
}